import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from './lib/auth';
import { AuthGuard } from './routes/AuthGuard';
import { Login } from './routes/Login';
import { Dashboard } from './routes/Dashboard';
import { Reports } from './routes/Reports';
import { ReportDetail } from './routes/ReportDetail';
import { Sends } from './routes/Sends';
import { EngagementHealth } from './routes/EngagementHealth';
import { Outreach } from './routes/Outreach';
import { Sows } from './routes/Sows';
import { SowEditor } from './routes/SowEditor';
import { Inbox } from './routes/Inbox';
import { ChemistryChecks } from './routes/ChemistryChecks';
import { Affiliates } from './routes/Affiliates';
import { Settings } from './routes/Settings';
import { Team } from './routes/Team';
import { Welcome } from './routes/Welcome';
import { ForgotPassword } from './routes/ForgotPassword';

import './styles/ds.css';
import './styles/dashboard.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/" element={<AuthGuard><Dashboard /></AuthGuard>} />
            <Route path="/reports" element={<AuthGuard><Reports /></AuthGuard>} />
            <Route path="/reports/:id" element={<AuthGuard><ReportDetail /></AuthGuard>} />
            <Route path="/sends" element={<AuthGuard><Sends /></AuthGuard>} />
            <Route path="/engagement-health" element={<AuthGuard><EngagementHealth /></AuthGuard>} />
            <Route path="/outreach" element={<AuthGuard><Outreach /></AuthGuard>} />
            <Route path="/sow" element={<AuthGuard><Sows /></AuthGuard>} />
            <Route path="/sow/:oppId" element={<AuthGuard><SowEditor /></AuthGuard>} />
            <Route path="/inbox" element={<AuthGuard><Inbox /></AuthGuard>} />
            <Route path="/chemistry-checks" element={<AuthGuard><ChemistryChecks /></AuthGuard>} />
            <Route path="/affiliates" element={<AuthGuard><Affiliates /></AuthGuard>} />
            <Route path="/settings" element={<AuthGuard><Settings /></AuthGuard>} />
            <Route path="/settings/team" element={<AuthGuard adminOnly><Team /></AuthGuard>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
